/** @type {import('../schema').ProcessDefinition} */
const pagos = {
  id: "pagos",
  name: "Pagos (cobro al residente)",
  category: "finanzas",
  outcome: "El residente paga su deuda y queda registrada y verificada.",
  trigger:
    "El residente paga desde Mis pagos; o el Administrador registra un pago manual.",
  actors: ["Residente", "Administrador", "Sistema", "Pasarela de pago"],
  status: "COMPLETO",
  description:
    "Cobro al residente vía transferencia manual con comprobante y verificación del admin, o registro manual de pagos (incluye parciales) con recibo.",
  lanes: [
    { id: "res", actor: "Residente" },
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    {
      id: "s0",
      laneId: "res",
      type: "start",
      label: "Inicio del cobro",
      description:
        "El residente decide pagar desde Mis pagos, o el Administrador opta por registrar un pago manual.",
    },
    {
      id: "s1",
      laneId: "res",
      type: "task",
      label: "Armado del carrito",
      description:
        "Selecciona uno o varios pagos. El provider activo (transferencia manual) los agrupa por edificio destino.",
      evidence: "src/components/PaymentCheckoutModal.jsx:1-40",
    },
    {
      id: "s2",
      laneId: "res",
      type: "document",
      label: "Pago por afuera + comprobante",
      description:
        "Ve la cuenta bancaria del edificio, transfiere y sube el comprobante por grupo. Los pagos quedan pendiente_verificacion con un cartGroupId común.",
      evidence: "src/services/paymentProviders/mercadoPago.js",
    },
    {
      id: "s3",
      laneId: "admin",
      type: "decision",
      label: "¿El comprobante coincide con el monto?",
      description:
        "El Administrador revisa el comprobante para aprobar o rechazar.",
    },
    {
      id: "s4",
      laneId: "admin",
      type: "task",
      label: "Aprobación",
      description:
        "Marca aprobado y paid si se saldó; salda multas/amenities vinculados.",
    },
    {
      id: "s5",
      laneId: "admin",
      type: "task",
      label: "Rechazo con motivo",
      description:
        "Marca rechazado y revierte el monto, indicando el motivo (comprobante inválido, monto no coincide o pago duplicado).",
    },
    {
      id: "s6",
      laneId: "admin",
      type: "task",
      label: "Registro manual",
      description:
        "Carga monto + método (transferencia/tarjeta/efectivo) + fecha. Soporta pagos parciales (recalcula remanente; paid solo si remanente <= 0).",
      evidence: "src/components/ManualPaymentModal.jsx",
    },
    {
      id: "s7",
      laneId: "sys",
      type: "document",
      label: "Recibo",
      description: "Genera el recibo del pago saldado.",
      evidence: "src/screens/admin/RecibosAdmin.jsx",
    },
    {
      id: "s8",
      laneId: "sys",
      type: "end",
      label: "Pago registrado y verificado",
    },
    {
      id: "s9",
      laneId: "admin",
      type: "end",
      label: "Pago rechazado",
    },
  ],
  transitions: [
    { from: "s0", to: "s1", label: "Residente paga" },
    { from: "s0", to: "s6", label: "Admin registra manual" },
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "Coincide" },
    { from: "s3", to: "s5", label: "No coincide" },
    { from: "s4", to: "s7" },
    { from: "s6", to: "s7" },
    { from: "s5", to: "s9" },
    { from: "s7", to: "s8" },
  ],
};
export default pagos;
